<template>
    <VTabs v-bind="$attrs" :class="classList" v-on="$listeners">
        <slot />
    </VTabs>
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-tabs';

export default {
    name: 'SrTabs',
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
};
</script>
